import Rubrics from '../rubrics/rubrics.js';

const rubricTemplateBank = new Rubrics();

export default {
    'RubricTemplates/SET_CRITERIA': {
        fields: ['title', 'description', 'max_value', 'criteria_ratings'],
        callback: async (store, mutation) => {
            await rubricTemplateBank.setRubricTemplateCriteria(store, mutation);
        },
    },

    'RubricTemplates/PUSH_RATING': {
        fields: ['criteria_ratings'],
        callback: async (store, mutation) => {
            await rubricTemplateBank.pushRubricTemplateRating(store, mutation);
        },
    },

    'RubricTemplates/EDIT': {
        fields: ['title', 'id'],
        callback: async (store, mutation) => {
            if (mutation.payload.field !== 'title') {
                await rubricTemplateBank.saveRubricTemplate(store, mutation);
            }
            if (mutation.payload.field === 'title' && mutation.payload.value.length > 0) {
                await rubricTemplateBank.saveRubricTemplate(store, mutation);
            }
        },
    },

    'RubricTemplates/SET_RATING': {
        fields: ['value'],
        callback: async (store, mutation) => {
            await rubricTemplateBank.setRubricTemplateRating(store, mutation);
        },
    },

    'RubricTemplates/REMOVE_RATING': {
        fields: ['criteria_ratings'],
        callback: async (store, mutation) => {
            await rubricTemplateBank.removeRubricTemplateRating(store, mutation);
        },
    },

    'RubricTemplates/REMOVE_CRITERIA': {
        fields: ['criterias'],
        callback: async (store, mutation) => {
            await rubricTemplateBank.removeRubricTemplateCriteria(store, mutation);
        },
    },

    'RubricTemplates/REORDER': {
        fields: ['reorder'],
        callback: async (store, mutation) => {
            await rubricTemplateBank.saveRubricTemplate(store, mutation);
        },
    },

    'RubricTemplates/DELETE_RUBRIC_CRITERIA_TEMPLATE': {
        fields: ['delete'],
        callback: async (store, mutation) => {
            await rubricTemplateBank.removeRubricTemplateCriteria(store, mutation);
        },
    },
};
